// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1f_3s","fileBtn":"File_fileBtn__b6Yjd","closeBtn":"File_closeBtn__3jQJz","fileSelected":"File_fileSelected__3bKC8","disabled":"File_disabled__1XOHd"};